import { render, staticRenderFns } from "./menu-add-or-update-copy.vue?vue&type=template&id=4e2a9f84&lang=pug"
import script from "./menu-add-or-update-copy.vue?vue&type=script&lang=js"
export * from "./menu-add-or-update-copy.vue?vue&type=script&lang=js"
import style0 from "./menu-add-or-update-copy.vue?vue&type=style&index=0&id=4e2a9f84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports